import { FlowRoute, FlowRouteCategory, FlowActions } from '@eneco/flows/types';

import { FlowConsumerContextEnergy } from './context';
import {
  shouldSkipWhenNoGas,
  shouldSkipWhenNoGasUpsellProductAvailable,
  shouldSkipWhenNoRentalDeviceCrossSellProductAvailable,
  shouldSkipWhenOnlyGeothermalHeating,
  shouldSkipWhenOnlyWarmth,
} from './eneco/skippingRules';
import {
  CrossSellRentalDeviceStep,
  DeliveryDateStep,
  OfferStep,
  SummaryStep,
  SustainableChoiceStep,
} from './eneco/steps';
import { flowActions, addressRoute, createUsageCalculationRoutes, detailsTailRoutes } from './shared/flowConfig';
import { AddressDetailsStep, EnergyChoiceStep, MovingStep } from './shared/steps';

export const initialContext: FlowConsumerContextEnergy = {};

export const routes: FlowRoute<FlowConsumerContextEnergy>[] = [
  addressRoute,
  {
    id: 'ENERGY_CHOICE',
    path: '/energiekeuze/',
    category: FlowRouteCategory.Calculation,
    component: EnergyChoiceStep,
    actions: ['resetUsageValues'],
  },

  ...createUsageCalculationRoutes({ includeWarmthRules: true }),

  {
    id: 'MOVING',
    path: '/je-gegevens/verhuizen/',
    category: FlowRouteCategory.Calculation,
    component: MovingStep,
    skippingRules: [],
  },

  {
    id: 'OFFER',
    path: '/productkeuze/looptijd/',
    category: FlowRouteCategory.Overview,
    component: OfferStep,
    skippingRules: [shouldSkipWhenOnlyWarmth, shouldSkipWhenOnlyGeothermalHeating],
  },

  {
    id: 'CO2UPSELL',
    path: '/productkeuze/co2-gas/',
    category: FlowRouteCategory.Overview,
    component: SustainableChoiceStep,
    skippingRules: [shouldSkipWhenNoGas, shouldSkipWhenNoGasUpsellProductAvailable],
  },

  {
    id: 'CROSS_SELL_RENTAL_DEVICE',
    path: '/productkeuze/huurapparaat/',
    category: FlowRouteCategory.Overview,
    component: CrossSellRentalDeviceStep,
    skippingRules: [shouldSkipWhenNoRentalDeviceCrossSellProductAvailable],
  },

  {
    id: 'DELIVERY_DATE',
    path: '/je-gegevens/start-leverdatum/',
    category: FlowRouteCategory.Details,
    component: DeliveryDateStep,
  },

  {
    id: 'ADDRESS_DETAILS',
    path: '/je-gegevens/adresgegevens/',
    category: FlowRouteCategory.Details,
    component: AddressDetailsStep,
    skippingRules: [shouldSkipWhenOnlyWarmth, shouldSkipWhenOnlyGeothermalHeating],
  },

  ...detailsTailRoutes,

  {
    id: 'SUMMARY',
    path: '/je-gegevens/controle-keuze/',
    category: FlowRouteCategory.Summary,
    component: SummaryStep,
  },
];

export const actions: FlowActions<FlowConsumerContextEnergy> = flowActions;
